import { cn } from 'component-library';
import { ReactNode } from 'react';

import { I18String } from '@/components/widgets/a/I18String/I18String';
import { isNullish } from '@/utils/booleans';

export type TextAtomProps = {
  text?: string;
  className?: string;
  i18nPath?: string;
  children?: ReactNode;
  values?: { [key: string]: string | number };
};

export const TextContainer = ({
  text,
  i18nPath,
  children,
  className,
  dataTestid,
  values,
}: TextAtomProps & { dataTestid?: string }) => {
  if (isNullish(text) && isNullish(i18nPath) && isNullish(children)) {
    return null;
  }

  if (i18nPath) {
    return <I18String className={className} data-testid={dataTestid} i18nPath={i18nPath} values={values} />;
  }

  return (
    <span className={className} data-testid={dataTestid}>
      {text ?? children}
    </span>
  );
};

export const Header = ({ className, ...props }: TextAtomProps) => {
  return (
    <TextContainer dataTestid='text-header' className={cn('typography-h4 whitespace-pre-wrap', className)} {...props} />
  );
};

export const Body = ({ className, ...props }: TextAtomProps) => {
  return (
    <TextContainer
      dataTestid='text-body'
      className={cn('typography-body2 text-text-secondary whitespace-pre-wrap', className)}
      {...props}
    />
  );
};

export const Footer = ({ className, ...props }: TextAtomProps) => {
  return (
    <TextContainer
      dataTestid='text-footer'
      className={cn('whitespace-pre-wrap typography-body2 text-text-secondary', className)}
      {...props}
    />
  );
};
